module.exports = __webpack_public_path__ + "img/xset.50f17357.png";